<template>
  <div class="DarkWhite pa-4">
      <MyRequests :request="request" />
  </div>
</template>

<script>
import MyRequests from '../components/Utils/MyRequests.vue'
  export default {
    components: {
      MyRequests
    },
    data: () => ({
      // request: false,
    }),
    watch: {
    },
    mounted() {
    },
    methods: {
      // createRequest(){
      //   this.request = true;
      // }
    //   getFiscalYears() {
    //   this.fiscalyears = [{id: 0, fiscalYear: "All"}]
    //   this.axiosCall("/getAllFiscalYear", "GET").then((res) => {
    //     this.fiscalyears = [{id: 0, fiscalYear: "All"}, ...res.data.data]
    //     this.fiscalYear = this.$store.state.fiscalYear != null ? this.$store.state.fiscalYear : res.data.data[0].id
    //   });
    // },
    }
  }
</script>

<style scoped>
</style>